document.addEventListener("click", (event) => {
  const thumb = event.target.closest("[data-semora-thumb]");
  if (!thumb) return;

  const gallery = thumb.closest("[data-semora-gallery]");
  if (!gallery) return;

  const mainImage = gallery.querySelector("[data-semora-main-image]");
  if (!mainImage || !thumb.dataset.src) return;

  gallery.querySelectorAll("[data-semora-thumb]").forEach((item) => item.classList.remove("is-active"));
  thumb.classList.add("is-active");
  mainImage.src = thumb.dataset.src;
  mainImage.style.objectPosition = thumb.dataset.position || "center 54%";
});
